import { gql } from '@apollo/client';
const REMOVE_TENANT_SIZING = gql `
  mutation RemoveTenantSizing($modelSpecificationSizeStandardId: ID!) {
    removeModelSpecificationSizeStandard(
      modelSpecificationSizeStandardId: $modelSpecificationSizeStandardId
    ) {
      removed
    }
  }
`;
export default REMOVE_TENANT_SIZING;
